export const DividerFields = `
{
    has_image
}`;
